export default class EnterpriseNotification {

    public id = "";
    public mailAddress = "";
    public notification = false;
}